import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../dataservice/config";
import { backend_url } from "../../aZxPqR";
import { decryptDatapayload, encryptDatapayload } from "../../helpers/common";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${backend_url}v2`,
  prepareHeaders: (headers) => {
    const customHeaders = getHeaders();

    Object.entries(customHeaders).forEach(([key, value]) => {
      if (value) headers.set(key, value);
    });

    return headers;
  },
});

const customBaseQuery = async (args, api, extraOptions) => {
  let modifiedArgs = typeof args === "string" ? { url: args } : { ...args };

  // request encrypt (skip FormData)
  if (
    modifiedArgs?.body &&
    !(modifiedArgs.body instanceof FormData) &&
    typeof modifiedArgs.body === "object"
  ) {
    modifiedArgs.body = {
      payload: encryptDatapayload(modifiedArgs.body),
    };
  }

  const result = await rawBaseQuery(modifiedArgs, api, extraOptions);

  // response decrypt
  if (result?.data) {
    result.data = decryptDatapayload(result.data);
  }
  return result;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery,
  tagTypes: ["user"],
  endpoints: (builder) => ({
    username: builder.mutation({
      query: (datas) => ({
        url: "user/check_username",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),
    useremail: builder.mutation({
      query: (datas) => ({
        url: "/user/check_email",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),
    register: builder.mutation({
      query: (datas) => ({
        url: "/user/register_user",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),
    resendOtp: builder.mutation({
      query: (datas) => ({
        url: "/user/resend_otp",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),

    verifyOtp: builder.mutation({
      query: (datas) => ({
        url: "/user/verify_otp",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),

    login: builder.mutation({
      query: (datas) => ({
        url: "/user/login_user",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),

    loginverify: builder.mutation({
      query: (datas) => ({
        url: "/user/login_verify",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["user"],
    }),

    // GET /posts
    getuserprofile: builder.query({
      query: () => ({
        url: "/user/profile",
        // headers:getHeaders()
      }),
      providesTags: ["user"],
    }),

    updateuserprofile: builder.mutation({
      query: (newPost) => ({
        url: "/user/update_profile",
        method: "POST",
        body: newPost,
      }),
      invalidatesTags: ["user"],
    }),
    forgotpwd: builder.mutation({
      query: (newPost) => ({
        url: "/user/forgot_user",
        method: "POST",
        body: newPost,
      }),
      invalidatesTags: ["user"],
    }),
    //
    resetpwd: builder.mutation({
      query: (newPost) => ({
        url: "/user/reset_pass_user",
        method: "POST",
        body: newPost,
      }),
      invalidatesTags: ["user"],
    }),
    changepwd: builder.mutation({
      query: (newPost) => ({
        url: "/user/update_password",
        method: "POST",
        body: newPost,
      }),
      invalidatesTags: ["user"],
    }),
    userloginhistory: builder.query({
      query: ({ page, limit }) => ({
        url: `/user/login_history?page=${page}&&limit=${limit}`,
        headers: getHeaders(),
      }),
      providesTags: ["user"],
    }),
    userlogout: builder.mutation({
      query: (data) => ({
        url: "/user/logout_user",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["user"],
    }),
    kycupload: builder.mutation({
      query: (data) => ({
        url: "/user/update_kyc",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["user"],
    }),

    homecontent: builder.query({
      query: () => ({
        url: `/user/home_page`,
        headers: getHeaders(),
      }),
      providesTags: ["user"],
    }),

    faqcontent: builder.query({
      query: () => ({
        url: `/user/faq`,
        headers: getHeaders(),
      }),
      providesTags: ["user"],
    }),

    sitesettinge: builder.query({
      query: () => ({
        url: `/user/site_settings`,
        // headers:getHeaders()
      }),
      providesTags: ["user"],
    }),

    singlepagecms: builder.mutation({
      query: (data) => ({
        url: `/user/get_cms`,
        method: "POST",
        headers: getHeaders(),
        body: data,
      }),
      invalidatesTags: ["user"],
    }),
  }),
});

// Auto-generated hooks
export const {
  useRegisterMutation,
  useUsernameMutation,
  useUseremailMutation,
  useResendOtpMutation,
  useVerifyOtpMutation,
  useLoginMutation,
  useLoginverifyMutation,
  useGetuserprofileQuery,
  useUpdateuserprofileMutation,
  useForgotpwdMutation,
  useResetpwdMutation,
  useChangepwdMutation,
  useUserloginhistoryQuery,
  useUserlogoutMutation,
  useKycuploadMutation,

  useHomecontentQuery,
  useFaqcontentQuery,
  useSinglepagecmsMutation,
  useSitesettingeQuery,
} = api;
